import { type FsmDefLiveChatState } from "@do/shared-types";
import { useEffect } from "react";
import { useChat } from "../../../../providers/chat-provider";

type LiveChatStepProps = {
  liveChatConfigId: FsmDefLiveChatState["meta"]["liveChatConfigId"];
  payload: Record<string, string>;
};

export const MessageStepLiveChat = ({ liveChatConfigId, payload }: LiveChatStepProps) => {
  const { onFastAction } = useChat();

  useEffect(() => {
    onFastAction({
      liveChat: { configId: liveChatConfigId, payload },
      title: "liveChat",
    });
  }, [liveChatConfigId, onFastAction, payload]);

  return null;
};
